import { ModalWrapper, TimeSwitch } from "src/utils/fw"
import { isMember } from "../utils"
import { AgendaSidebar } from "../components/AgendaSidebar"
import auditoriumTwo from "../data/auditoriumTwo"
import IBM from "./modals/IBM"


const memberLinks = [
	{
		height: "15.7%",
		href: "/atrium",
		isExternal: false,
		label: "Atrium",
		left: "38.3%",
		top: "80.9%",
		width: "7.6%",
	},
	{
		height: "15.7%",
		href: "https://isfcongress.tkeventsregistration.com/feedbackaud2",
		label: "Feedback",
		left: "46.1%",
		target: "_blank",
		top: "80.9%",
		width: "7.6%",
	},
	{
		height: "15.7%",
		modal: <ModalWrapper wrapperStyle={{height: "fit-content", maxHeight: "100%", backgroundColor: "rgb(59, 80, 206)"}}>
			<iframe src="https://app.sli.do/event/cNSWBCFC68rnHFuGcm6wQ9" height="100%" width="100%" frameBorder="0" style="height: 95.8vh; width: 400px" title="Slido"></iframe>
		</ModalWrapper>,
		modalOverrides: {
			backdropStyle: {
				justifyContent: "flex-start",
				"background": "none"
			},
			dismissHTML: "X",
			dismissStyle: {
				color: "white",
				"font-size": "20px"
			}
		},
		label: "Slido",
		left: "54.1%",
		top: "80.9%",
		width: "7.6%",
	},
]

export default {
	background: "https://assets.swoogo.com/uploads/full/2938959-6511c557bf5c7.png",
	 extras: (
		<>
			<div style={{
				height: "70.4%",
				left: "19%",
				top: "5.1%",
				width: "62.05%",
				position: "absolute"
			}}>
				<iframe
					src="https://vimeo.com/event/3816121/embed?mute=false"
					allowfullscreen
					allow="autoplay"
					style={{
						height: "100%",
						width: "100%",
						border: 0
					}}
				/>
			</div>
			<div style={{
				height: "85.1%",
				left: "82.3%",
				top: "2.1%",
				width: "16.7%",
				position: "absolute",
				textAlign: "right"
			}}>
				<AgendaSidebar agenda={auditoriumTwo()} />
			</div>
			<TimeSwitch>
				{[
					{
						starts: new Date("2023-10-10 10:15:00+0200"),
						ends: new Date("2023-10-23 10:14:00+0200"),
						content: <></>
					},
					{
						starts: new Date("2023-10-23 10:15:00+0200"),
						ends: new Date("2023-10-23 11:00:00+0200"),
						content: <IBM />
					}
				]}
			</TimeSwitch>
	</>
	 ),
	links: [
		...(isMember ? memberLinks : []),
	],
	name: "auditorium-two",
}
